import { Button, Form, FormProps, Icons, Input, Select, Space, useSelect } from "@pankod/refine-antd";
import { useOne } from "@pankod/refine-core";
import { RenderSpinner } from "components/common";
import { ILookup } from "interfaces";
import { ITechJamMetadata } from "interfaces/article";
import { DATAPROVIDER_LOOKUP, RESOURCE_PATH, STALE_DURATION } from "scripts/site";

export const TechJamFilter: React.FC<{
    formProps: FormProps,
    onApplyFilter?: () => void,
}> = ({ formProps, onApplyFilter }) => {
    const { isLoading, data: metadata } = useOne<ITechJamMetadata>({
        dataProviderName: DATAPROVIDER_LOOKUP,
        resource: RESOURCE_PATH.METADATA,
        id: RESOURCE_PATH.TECHJAM,
        queryOptions: {
            enabled: true,
            staleTime: STALE_DURATION
        }
    });

    const { selectProps: userProps } = useSelect<ILookup>({
        dataProviderName: DATAPROVIDER_LOOKUP,
        resource: RESOURCE_PATH.PEOPLE,
        optionLabel: "nameEmail",
        optionValue: "id",
        filters: [{
            field: "stateManager.state",
            operator: "eq",
            value: "active"
        }],
        sort: [{
            field: "lastAccessedAt",
            order: "desc"
        }],
        fetchSize: 50
    });

    const metaConfig = metadata?.data.config;

    if (isLoading) {
        return <RenderSpinner message="Loading..." />;
    }

    return (
        <Form layout="vertical" {...formProps} autoComplete="off">
            <Form.Item
                label={"Search"}
                name="q"
                tooltip={metaConfig?.search?.textMessages?.searchTextPlaceholder || "Search"}
            >
                <Input
                    placeholder={metaConfig?.search?.textMessages?.searchTextPlaceholder || "Search"}
                    prefix={<Icons.SearchOutlined />}
                />
            </Form.Item>
            <Form.Item
                label="Speakers"
                name="authorName"
                tooltip="To look up any missing name type the name of the person and then select"
            >
                <Select
                    allowClear
                    placeholder="Speakers"
                    {...userProps}
                />
            </Form.Item>
            <Form.Item>
                <Space>
                    <Button
                        htmlType="submit"
                        type="primary"
                        icon={<Icons.FilterOutlined />}
                        onClick={() => {
                            onApplyFilter && onApplyFilter();
                        }}
                    >
                        Apply
                    </Button>
                    <Button
                        icon={<Icons.ClearOutlined />}
                        htmlType="submit"
                        onClick={() => { formProps.form?.resetFields(); }}
                    >
                        Clear
                    </Button>
                </Space>
            </Form.Item>
        </Form>
    );
};